/**
 * EN-1518: POST /pigrun/DownloadRecordedPassageDataRequest and
 * POST /pigrun/DownloadRecordedRawDataRequest refuse the whole request with
 * an empty 403 unless the caller is an administrator and every requested AGM
 * is in the caller's group (a super admin may use any AGM).
 */

export const DOWNLOAD_NOT_ALLOWED_TITLE = 'Download Not Allowed';

export const DOWNLOAD_NOT_ALLOWED_MESSAGE =
  'Only administrators can queue downloads, and only from AGMs in their own group.';

/**
 * The message to show the user when `error` is the API's 403 for a download
 * request, otherwise null so the caller keeps its existing error handling.
 */
export function downloadRequestForbiddenMessage(error: unknown): string | null {
  const status = (error as { response?: { status?: number } } | null)?.response
    ?.status;
  return status === 403 ? DOWNLOAD_NOT_ALLOWED_MESSAGE : null;
}
